import React, { useState } from 'react';

export const LabelTituloGeneral = ({titulo}) => {
    return (
        <label className="lg:text-xl text-[#336fbb] text-[25px] underline">{titulo}</label>
    )
}